import { cn } from '@/utils';
import { type QuizListItemTitleProps } from '../types/quiz-list-item.types';
export const QuizListItemTitle = ({
  title,
  className,
  maxLines = 2,
  onClick
}: QuizListItemTitleProps) => {
  return <h3 className={cn('text-heading-sm-bold text-default word-break-all', maxLines === 1 && 'line-clamp-1', maxLines === 2 && 'line-clamp-2 max-h-[56px]', maxLines === 3 && 'line-clamp-3', onClick && 'cursor-pointer hover:underline', className)} onClick={onClick} data-sentry-component="QuizListItemTitle" data-sentry-source-file="QuizListItemTitle.tsx">
      {title}
    </h3>;
};